// Fase 14A — Dizionario italiano (master). Chiavi stabili (punto 68).
// La business logic non vive mai qui: solo testi di presentazione (punto 139).
export default {
  "app.name": "ESG-PMI",
  "app.tagline": "Standard VSME",

  "nav.group.panoramica": "PANORAMICA",
  "nav.group.myEsg": "IL MIO ESG",
  "nav.group.pianificazione": "PIANIFICAZIONE",
  "nav.group.reporting": "REPORTING & AUDIT",
  "nav.group.gestione": "GESTIONE AZIENDALE",
  "nav.group.admin": "AMMINISTRAZIONE",
  "nav.group.consulente": "CONSULENTE",
  "nav.group.aziendaSelezionata": "AZIENDA SELEZIONATA",

  "nav.nav-dashboard": "Dashboard",
  "nav.nav-portafoglio": "Portafoglio clienti",
  "nav.nav-note-interne": "Note interne",
  "nav.nav-esg": "Environmental · Social · Governance",
  "nav.nav-questionario": "Questionario ESG",
  "nav.nav-questionario-mef": "Questionario MEF – Banche",
  "nav.nav-environmental": "Environmental Engine",
  "nav.nav-social": "Social Engine",
  "nav.nav-governance": "Governance Engine",
  "nav.nav-eva": "Eva — ESG Assistant",
  "nav.nav-vsme": "VSME",
  "nav.nav-documenti": "Documenti",
  "nav.nav-jobtimehr": "JOBTIMEHR",
  "nav.nav-piano": "Piano di miglioramento",
  "nav.nav-obiettivi": "Obiettivi",
  "nav.nav-simulazioni": "Simulazioni",
  "nav.nav-questionari": "Questionari esterni",
  "nav.nav-dataroom": "Data Room",
  "nav.nav-valutazione": "Valutazione ESG",
  "nav.nav-report": "Report",
  "nav.nav-pmi-banche": "Dossier PMI-Banche",
  "nav.nav-data-room": "Data Room",
  "nav.nav-audit-log": "Registro attività",
  "nav.nav-azienda": "Anagrafica Azienda",
  "nav.nav-utenti": "Utenti e Ruoli",
  "nav.nav-periodi": "Periodi di rendicontazione",
  "nav.nav-impostazioni": "Impostazioni",
  "nav.nav-percorso": "Percorso guidato",
  "nav.nav-onboarding": "Onboarding & Autofill",
  "nav.nav-attivita": "Attività da revisionare",
  "nav.nav-dashboard-consulente": "Dashboard consulente",

  "admin.standard": "Standard Management",
  "admin.factors": "Emission Factors",
  "admin.questions": "Question Library",
  "admin.frameworks": "Frameworks",
  "admin.mefIndicators": "Indicatori PMI–Banche",
  "admin.metodologie": "Metodologie Score",
  "admin.demoRequests": "Demo Requests",
  "admin.eva": "EVA Admin",
  "admin.languages": "Lingue e traduzioni",
  "admin.regulatory": "Regulatory Update Center",
  "admin.system": "Stato sistema",

  "header.newCompany": "Nuova azienda",
  "header.selectCompany": "Seleziona azienda",
  "header.selectPeriod": "Periodo",
  "header.fiscalYear": "Esercizio",
  "header.jtNotConnected": "JOBTIMEHR: NON COLLEGATO",
  "header.role": "Ruolo",
  "header.settings": "Impostazioni",
  "header.logout": "Esci",
  "header.openMenu": "Apri menu",

  "company.empty.title": "Nessuna azienda associata",
  "company.empty.text": "Crea la tua prima azienda per iniziare a usare la piattaforma ESG.",
  "company.empty.cta": "Crea azienda",

  "dialog.newCompany.title": "Nuova azienda",
  "dialog.newCompany.name": "Denominazione *",
  "dialog.newCompany.piva": "Partita IVA",
  "dialog.newCompany.creating": "Creazione…",
  "dialog.newCompany.submit": "Crea azienda",
  "dialog.newCompany.created": "Azienda creata",

  "language.label": "Lingua",
  "language.choose": "Scegli la tua lingua",
  "language.chooseDesc": "Puoi cambiarla in qualsiasi momento dall'intestazione o dalle impostazioni. Il cambio non modifica dati, valori o periodi.",
  "language.continue": "Continua in italiano",
  "language.current": "Lingua attuale",

  "help.askEvaPage": "Chiedi a Eva come usare questa pagina",
  "help.askEvaPageQuestion": "Cosa devo fare in questa pagina?",
  "help.reserved_consultant": "Questa funzione è riservata al consulente che segue l'azienda.",
  "help.fallbackNotice": "Questa guida non è ancora disponibile nella lingua selezionata: viene mostrata la versione italiana di riferimento.",

  "button.save": "Salva",
  "button.cancel": "Annulla",
  "button.create": "Crea",
  "button.delete": "Elimina",
  "button.edit": "Modifica",
  "button.confirm": "Conferma",
  "button.close": "Chiudi",
  "button.send": "Invia",
  "button.download": "Scarica",
  "button.upload": "Carica",
  "button.back": "Indietro",

  "common.loading": "Caricamento in corso…",
  "common.error": "Errore",
  "common.noData": "DATI NON ANCORA DISPONIBILI",
  "common.demo": "DEMO",

  "login.heroTitle": "Il sistema operativo ESG delle PMI.",
  "login.heroText": "Rispondi come imprenditore. Il software ragiona come esperto ESG. Raccogli, organizza e rendiconta i dati di sostenibilità secondo lo standard VSME.",
  "login.title": "Accedi",
  "login.subtitle": "Inserisci le tue credenziali per continuare.",
  "login.signingIn": "Accesso in corso…",
  "login.noAccount": "Non hai un account?",
  "login.register": "Registrati",

  "settings.title": "Impostazioni",
  "settings.subtitle": "Profilo utente, lingua e aziende associate.",
  "settings.profile": "Profilo utente",
  "settings.name": "Nome",
  "settings.platformLevel": "Livello piattaforma",
  "settings.companyUser": "Utente aziendale",
  "settings.platformLevels.SUPER_ADMIN": "Super Admin",
  "settings.platformLevels.ORG_ADMIN": "Admin Studio",
  "settings.platformLevels.CONSULENTE": "Consulente",
  "settings.platformLevels.UTENTE_AZIENDA": "Utente aziendale",
  "header.switchToCompany": "Passa al contesto Azienda",
  "header.switchToConsultant": "Passa al contesto Consulente",
  "header.contextSwitched": "Contesto aggiornato",
  "settings.accountCreated": "Account creato il",
  "settings.memberships": "Aziende associate",
  "settings.security": "Sicurezza",
  "settings.securityText": "La piattaforma utilizza autenticazione JWT con password cifrate (bcrypt), sessioni sicure, controllo degli accessi lato server e isolamento completo dei dati tra aziende. La modifica della password e l'autenticazione a due fattori saranno disponibili nelle prossime fasi.",
  "settings.language.title": "Lingua",
  "settings.language.text": "La lingua è una preferenza personale: interfaccia, Eva e guida si aggiornano subito, senza logout. Non modifica dati, valori o periodi.",
  "settings.language.saved": "Lingua aggiornata",
  "settings.manual.title": "Manuale operativo",
  "settings.manual.text": "La guida operativa ESG-PMI in PDF, generata dalla stessa Knowledge Base di Eva.",
  "settings.manual.clientIt": "Guida Azienda — Italiano",
  "settings.manual.clientEn": "Company User Guide — English",
  "settings.manual.consultantIt": "Manuale Consulente — Italiano",
  "settings.manual.consultantEn": "Consultant Manual — English",

  "periodStatus.DRAFT": "Bozza",
  "periodStatus.IN_PROGRESS": "In corso",
  "periodStatus.IN_REVIEW": "In revisione",
  "periodStatus.APPROVED": "Approvato",
  "periodStatus.LOCKED": "Bloccato",

  "roleLabels.SUPER_ADMIN": "Super Admin",
  "roleLabels.CONSULENTE": "Consulente",
  "roleLabels.ADMIN_AZIENDA": "Admin Azienda",
  "roleLabels.ESG_MANAGER": "ESG Manager",
  "roleLabels.HR_MANAGER": "HR Manager",
  "roleLabels.DATA_ENTRY": "Data Entry",
  "roleLabels.VIEWER": "Viewer",
  "roleLabels.REVISORE": "Revisore",
  "roleLabels.null": "Ruolo non assegnato",

  "eva.title": "Eva — ESG Assistant",
  "eva.subtitle": "L'assistente intelligente di ESG-PMI. Utilizza i dati autorizzati della piattaforma per rispondere.",
  "eva.newConversation": "Nuova conversazione",
  "eva.noConversations": "Nessuna conversazione precedente.",
  "eva.welcomeTitle": "Ciao, sono Eva.",
  "eva.welcomeText": "Posso aiutarti a capire i dati ESG della tua azienda, verificare cosa manca per VSME e Questionario MEF - Banche, guidarti nell'uso della piattaforma e spiegarti i KPI già disponibili.",
  "eva.welcomeConsultant": "Come consulente puoi anche chiedermi di preparare report, Data Room, scenari e azioni di miglioramento: ti chiederò sempre conferma prima di eseguire qualsiasi azione.",
  "eva.placeholder": "Chiedi a Eva qualcosa sui tuoi dati ESG o su come usare la piattaforma…",
  "eva.footerNote": "Eva usa solo i dati autorizzati della piattaforma, dichiara quando un'informazione non è disponibile e non esegue mai azioni di scrittura senza la tua conferma esplicita.",
  "eva.modeConsultant": "Modalità Consulente",
  "eva.modeClient": "Modalità Cliente",
  "eva.contextTitle": "Contesto di lavoro",
  "eva.contextCompany": "Azienda",
  "eva.contextPeriod": "Periodo",
  "eva.contextMode": "Modalità",
  "eva.sourcesTitle": "Fonti di questa conversazione",
  "eva.sourcesEmpty": "Le fonti utilizzate da Eva appariranno qui, con il link alla sezione della piattaforma da cui provengono i dati.",
  "eva.pendingConfirmations": "{count} azione/i in attesa della tua conferma",
  "eva.consulting": "Eva sta consultando",
  "eva.confirmation.proposes": "Eva propone",
  "eva.confirmation.highImpact": "AZIONE AD ALTO IMPATTO",
  "eva.confirmation.write": "AZIONE DI SCRITTURA",
  "eva.confirmation.hint": "L'azione viene eseguita solo con la tua conferma.",
  "eva.confirmation.executed": "✓ Azione eseguita dopo la tua conferma.",
  "eva.confirmation.cancelled": "Azione annullata.",
  "eva.confirmation.expired": "Conferma scaduta: chiedi di nuovo a Eva.",
  "eva.confirmation.failed": "Esecuzione non riuscita.",
  "eva.deleteConversation": "Elimina conversazione",
  "eva.stopAnswer": "Interrompi risposta",
  "eva.sendMessage": "Invia messaggio",
  "eva.regenerate": "Rigenera risposta",
  "eva.loading": "Caricamento di Eva…",
  "eva.accessDeniedTitle": "Eva non è disponibile per questo account",
  "eva.accessDeniedText": "Eva lavora sui dati ESG delle aziende. L'account Super Admin di piattaforma non ha accesso ai dati aziendali: per usare Eva accedi con un account aziendale o dello studio consulente.",

  "adminLang.title": "Lingue e traduzioni",
  "adminLang.subtitle": "Language & Translation Management: stato delle lingue, copertura dei contenuti, revisione traduzioni e feedback.",
  "adminLang.coverage": "Copertura",
  "adminLang.status": "Stato",
  "adminLang.reviewQueue": "Coda di revisione traduzioni",
  "adminLang.feedback": "Feedback sulle traduzioni",
  "adminLang.analytics": "Utilizzo (aggregato)",
  "adminLang.markVerified": "Verifica",
  "adminLang.markActive": "Attiva",
  "adminLang.deprecate": "Depreca",
  "adminLang.noTranslations": "Nessuna traduzione in revisione.",
  "adminLang.statusUpdated": "Stato aggiornato",

  "dash.title": "Dashboard ESG",
  "dash.welcome": "Benvenuto, {name}. Panoramica della sostenibilità di",
  "dash.activePeriod": "Periodo attivo:",
  "dash.fiscalYear": "Esercizio {year}",
  "dash.widget.score": "ESG PMI Score",
  "dash.widget.journey": "Risposte ESG valide",
  "dash.widget.vsme": "Datapoint VSME disponibili",
  "dash.widget.mef": "Questionario MEF – Banche",
  "dash.widget.companyData": "Dati azienda",
  "dash.widget.dataStatus": "Dati verificati / mancanti",
  "dash.widget.locker": "Cassetto ESG",
  "dash.widget.openActions": "Azioni aperte",
  "dash.widget.submission": "Invio al consulente",
  "dash.widget.sharedReports": "Report condivisi dal consulente",
  "dash.widget.extq": "Questionari esterni",
  "dash.widget.extqTodo": "Questionari da completare",
  "dash.pillar.e": "Ambientale",
  "dash.pillar.s": "Sociale",
  "dash.pillar.g": "Governance",
  "dash.missing": "Informazioni mancanti",
  "dash.toVerify": "Da verificare",
  "dash.docsUploaded": "Documenti caricati",
  "dash.govSections": "Aree Governance completamente compilate",
  "dash.govSectionsVerified": "di cui interamente verificate",
  "dash.tipGovSections": "Aree di governance con tutti i dati inseriti; la verifica finale spetta al consulente.",
  "dash.continue": "Continua la compilazione",
  "dash.openVsme": "Apri motore VSME",
  "dash.openMef": "Apri dossier banca",
  "dash.openValutazione": "Apri la Valutazione ESG (score metodologico + Data Quality)",
  "dash.openEngine": "Apri il motore",
  "dash.openLocker": "Apri il Cassetto ESG",
  "dash.openPlan": "Apri il piano",
  "dash.gotoQuestionnaire": "Vai al questionario",
  "dash.openExtq": "Apri i questionari",
  "dash.scoreSourceNote": "Score metodologico ESG PMI (ScoreRun): unica fonte ufficiale, calcolato sui dati canonici del periodo. Distinto dalla completeness VSME.",
  "dash.scoreEmpty": "Nessuna valutazione calcolata per questo esercizio.",
  "dash.scoreError": "Impossibile caricare lo score. Riprova tra poco.",
  "dash.scoreStale": "I dati sono cambiati dopo questo calcolo: lo score è da ricalcolare.",
  "dash.scoreStatus.CURRENT": "Aggiornato",
  "dash.scoreStatus.STALE": "Da ricalcolare",
  "dash.scoreStatus.INSUFFICIENT_DATA": "Dati insufficienti",
  "dash.scoreStatus.CALCULATING": "Calcolo in corso…",
  "dash.scoreStatus.FAILED": "Calcolo non riuscito",
  "dash.scoreInsufficient": "Copertura dati del periodo al {coverage}%: insufficiente per una valutazione affidabile.",
  "dash.pillarEmpty": "Nessun dato disponibile per questo pilastro nel periodo.",
  "dash.pillarStats": "{completed} disponibili · {missing} mancanti · datapoint VSME disponibili",
  "dash.notActive": "Non attivo",
  "dash.missingData": "Dati mancanti",
  "dash.approved": "Approvati",
  "dash.p1": "Prioritarie (P1)",
  "dash.coveredVsme": "Coperte da VSME",
  "dash.toIntegrate": "Da integrare",
  "dash.sector": "Settore",
  "dash.employees": "Dipendenti",
  "dash.managedUsers": "Utenti gestiti",
  "dash.esgPeriods": "Periodi ESG",
  "dash.verified": "Verificati",
  "dash.docsInPeriod": "documenti caricati nel periodo",
  "dash.docCoverage": "Documentazione completa al",
  "dash.docsRequestedOne": "documento richiesto dal consulente",
  "dash.docsRequestedMany": "documenti richiesti dal consulente",
  "dash.openActionsInPlan": "azioni aperte nel piano di miglioramento",
  "dash.submissionState": "Stato compilazione:",
  "dash.openRequests": "Richieste del consulente da evadere:",
  "dash.sharedReportsCount": "report approvati condivisi con la tua azienda",
  "dash.downloadPdf": "Scarica PDF",
  "dash.extqAwaiting": "in attesa di revisione",
  "dash.extqOne": "questionario da completare",
  "dash.extqMany": "questionari da completare",
  "dash.extqToComplete": "da completare",
  "dash.extqToVerify": "da verificare",
  "dash.askEva": "Chiedi a Eva",
  "dash.askEvaSub": "Cosa vuoi sapere sul tuo ESG?",
  "dash.askEvaPlaceholder": "Es. Cosa manca al mio VSME?",
  "dash.askEvaSubmit": "Chiedi",
  "dash.qCard.title": "Questionario ESG",
  "dash.qCard.completed": "Completato",
  "dash.qCard.inProgress": "In corso",
  "dash.qCard.notStarted": "Non iniziato",
  "dash.qCard.status": "Stato:",
  "dash.qCard.questions": "({answered} di {visible} domande)",
  "dash.qCard.empty": "Rispondi poche domande semplici: il software le traduce in dati VSME.",
  "dash.qCard.continue": "CONTINUA QUESTIONARIO",
  "dash.qCard.start": "INIZIA IL PERCORSO ESG",
  "dash.qCard.fullNote": "Il 100% indica che tutte le domande hanno una risposta. Le risposte devono ancora essere verificate dal consulente.",
  "dash.compileMef": "Compila il Questionario MEF – Banche",
  "dash.mefQuestions": "Domande compilate",
  "dash.mefCoverage": "Informazioni già disponibili dai dati ESG",
  "dash.mefToVerify": "Da verificare",
  "dash.openMefSummary": "Apri il riepilogo MEF",
  "dash.tipQuestionsPct": "Quota di domande MEF con risposta valida (coerente e senza controlli falliti) sulle domande della sezione Dialogo con la banca.",
  "dash.tipVsmePct": "Quota di informazioni VSME disponibili sui datapoint applicabili (fonte: motore VSME).",
  "dash.tipMefPct": "Quota delle 40 informazioni del Documento MEF già coperte dai dati inseriti (VSME o risposte dirette).",
  "questionnaireState.DA_INIZIARE": "Da iniziare",
  "questionnaireState.IN_COMPILAZIONE": "In compilazione",
  "questionnaireState.COMPLETO_DA_INVIARE": "Completo — da inviare al consulente",
  "questionnaireState.INVIATO_AL_CONSULENTE": "Inviato al consulente",
  "questionnaireState.IN_REVISIONE": "In revisione dal consulente",
  "questionnaireState.RICHIESTA_INTEGRAZIONE": "Integrazione richiesta dal consulente",
  "questionnaireState.ACCETTATO_PER_ANALISI": "Accettato per l'analisi",
  "questionnaireState.APPROVATO": "Approvato",
  "questionnaireState.RIAPERTO": "Riaperto per modifiche",
  "questionnaireState.DA_RIESAMINARE_INTEGRAZIONE_NECESSARIA": "Da integrare",
  "questionnaireState.INTEGRATION_REQUIRED": "Da integrare",
  "questionnaireState.DA_INTEGRARE": "Da integrare",
  "questionnaireState.PRONTO_PER_NUOVO_INVIO": "Pronto per nuovo invio",
  "questionnaireState.READY_FOR_RESUBMISSION": "Pronto per nuovo invio",
  "dash.nextSteps.title": "Prossimi passi consigliati",
  "dash.nextSteps.text": "Completa l'anagrafica aziendale, invita il tuo team e prepara i periodi di rendicontazione ESG.",
  "dash.nextSteps.company": "Anagrafica azienda",
  "dash.nextSteps.periods": "Periodi ESG",

  "submissionStatus.DRAFT": "Bozza — non inviata",
  "submissionStatus.SUBMITTED_BY_COMPANY": "Inviata al consulente",
  "submissionStatus.UNDER_CONSULTANT_REVIEW": "In revisione dal consulente",
  "submissionStatus.RETURNED_FOR_CORRECTION": "Restituita per integrazioni",
  "submissionStatus.ACCEPTED_FOR_ANALYSIS": "Accettata per l'analisi",
  "submissionStatus.APPROVED_BY_CONSULTANT": "Approvato dal consulente",
  "submissionStatus.SENT_TO_BANK": "Inviato alla banca",
  "questionnaireState.APPROVATO_DAL_CONSULENTE": "Approvato dal consulente",
  "questionnaireState.INVIATO_ALLA_BANCA": "Inviato alla banca",
  "submissionStatus.INTEGRATION_REQUIRED": "Da integrare",
  "submissionStatus.READY_FOR_RESUBMISSION": "Pronto per nuovo invio",
  "dash.validAnswersPct": "Risposte ESG valide",
  "dash.vsmeDatapointsPct": "Datapoint VSME disponibili",
  "dash.mefValidPct": "Domande MEF valide",
  "dash.govDatapointsPct": "Datapoint Governance VSME disponibili",
  "settings.subscription.title": "Abbonamento",
  "settings.subscription.current": "Piano attivo",
  "settings.subscription.none": "Nessun abbonamento attivo",
  "settings.subscription.choose": "Scegli piano",
  "settings.subscription.monthly": "mensile",
  "settings.subscription.yearly": "annuale",
  "settings.subscription.checkout_error": "Impossibile avviare il checkout",
  "settings.subscription.status": "Stato",
  "settings.subscription.manage_hint": "L'upgrade è immediato; non sono previsti downgrade automatici.",
};
